export default __webpack_public_path__ + "static/media/pgmico(13).09c3f775.png";